import {
  BUNDLE_APP_NAME,
  GET_APP_NAME_FOR_COLLECTION,
  IS_BUNDLE_APP,
  THIRD_PARTY_CONFIG,
} from "../../app_constant";
import { auth, firestore, storage } from "./config";
import { isAdminSignedIn } from "./admin";
import { normalizePromoCode } from "@learnzapp/core/pricing";
import { getEffectiveUid, isGhostMode } from "./ghostUid";
import axios from "axios";
import getStripe from "./stripe";

const collectionBundle = async () => {
  return firestore()
    .collection("apps")
    .doc(BUNDLE_APP_NAME)
    .collection("users")
    .doc(getEffectiveUid());
};

const collection = async () => {
  const APP_NAME = await GET_APP_NAME_FOR_COLLECTION();
  return firestore()
    .collection("apps")
    .doc(APP_NAME)
    .collection("users")
    .doc(getEffectiveUid());
};

const faqCollection = async () => {
  const APP_NAME = await GET_APP_NAME_FOR_COLLECTION();
  return firestore().collection("apps").doc(APP_NAME).collection("FAQS");
};

const commonFaqs = async () => {
  return firestore().collection("apps").doc("COMMON_FAQS").collection("FAQS");
};

const otherAppCollection = () => {
  // No orderBy("id"): Firestore orderBy silently DROPS docs missing the field,
  // and ordering now lives in @learnzapp/core selectOtherApps (adjacency map).
  return firestore().collection("apps").doc("OTHER_APPS").collection("Apps");
};

const allUserCollection = async () => {
  const APP_NAME = await GET_APP_NAME_FOR_COLLECTION();
  return firestore().collection("apps").doc(APP_NAME).collection("users");
};

async function UPDATE_USER_PROFILE(result) {
  try {
    const collection_user = await collection();
    await collection_user.set(result);
    return { status: true, error: "" };
  } catch (error) {
    return { status: false, error: error.message };
  }
}

async function UPDATE_BUNDLE_USER_PROFILE(result) {
  try {
    const collection_user = await collectionBundle();
    await collection_user.set(result);
    return { status: true, error: "" };
  } catch (error) {
    return { status: false, error: error.message };
  }
}

async function GET_BUNDLE_PROFILE() {
  try {
    const collection_user = await collectionBundle();
    const result = await collection_user.get();
    
    if (result.exists) {
      return {
        status: true,
        data: result.data(),
        error: "",
        isUserExist: true,
      };
    } else {
      return { status: true, data: null, error: "", isUserExist: false };
    }
  } catch (error) {
    return { status: false, data: null, error: error.message };
  }
}

async function GET_USER_PROFILE() {
  try {
    const collection_user = await collection();
    const result = await collection_user.get();

    // console.log('>>>>>>>>>>>>>>>>>>>>>>> GET_USER_PROFILE collection_user', collection_user);
    // console.log('>>>>>>>>>>>>>>>>>>>>>>> GET_USER_PROFILE result', result);
    
    if (result.exists === true) {
      return {
        status: true,
        data: result?.data(),
        error: "",
        isUserExist: true,
      };
    } else {
      return { status: true, data: null, error: "", isUserExist: false };
    }
  } catch (error) {
    return { status: false, data: null, error: error.message };
  }
}

async function UPDATE_NOTIFICATION_SETTING(quiz, study) {
  try {
    const collection_user = await collection();
    await collection_user.update({
      quiz_of_the_day_reminder: quiz,
      study_plan_reminder: study,
    });
    return { status: true, error: "" };
  } catch (error) {
    return { status: false, error: error.message };
  }
}

async function UPDATE_PROFILE_DETAILS(first_name, last_name) {
  try {
    const collection_user = await collection();
    await collection_user.update({
      auth_first_name: first_name,
      auth_last_name: last_name,
    });
    return { status: true, error: "" };
  } catch (error) {
    return { status: false, error: error.message };
  }
}




async function UPDATE_USER_AUTH_DETAILS() {
  // Skip in ghost mode — don't overwrite ghost user's auth details with admin's
  if (isGhostMode()) return { status: true, error: '' };

  try {
    const collection_user = await collection();
    await collection_user.update({
      auth_email: auth().currentUser.email,
      auth_login_provider:
        auth().currentUser?.providerData[0]?.providerId ?? "",
      last_signin_time: auth().currentUser.metadata?.lastSignInTime ?? "",
    });
    return { status: true, error: "" };
  } catch (error) {
    return { status: false, error: error.message };
  }
}

async function UPDATE_BUNDLE_PROFILE_DETAILS(first_name, last_name) {
  try {
    const collection_user = await collectionBundle();
    await collection_user.update({
      auth_first_name: first_name,
      auth_last_name: last_name,
    });
    return { status: true, error: "" };
  } catch (error) {
    return { status: false, error: error.message };
  }
}

async function UPLOAD_PROFILE(path) {
  // const blob = dataURLtoBlob(dataURL);
  // console.log("",blob);

  // var storageRef = storage.ref();

  // storageRef.put(path).then((snapshot) => {
  //   console.log(snapshot, "Uploaded a blob or file!");
  // });

  if (IS_BUNDLE_APP) {
    try {
      const user = auth()?.currentUser;

      if (!user) {
        throw new Error("User not authenticated");
      }

      const fileName = getEffectiveUid() + ".jpg";

      const reference = storage()?.ref();

      if (!reference) {
        throw new Error("Storage reference not available");
      }

      const imageRef = reference.child(fileName);

      try {
        if (imageRef) {
          await imageRef.put(path);
        } else {
          throw new Error("Image reference not available");
        }
      } catch (error) {
        console.error("Error uploading image:", error);
        throw error; // Re-throw the error to be caught in the outer catch block
      }

      const url = await imageRef.getDownloadURL();

      const collection_user = await collectionBundle();

      await collection_user.update({
        profile_pic: url,
      });

      return { status: true, error: "", url: url };
    } catch (error) {
      console.error("Error:", error);
      return { status: false, error: error.message, url: "" };
    }
  } else {
    try {
      const fileName = getEffectiveUid() + ".jpg" || "test.jpg";
      const reference = storage()?.ref();
      const imageRef = reference.child(fileName);
      await imageRef.put(path);
      const url = await imageRef.getDownloadURL();

      // const url = await storage().ref(fileName).getDownloadURL();

      const collection_user = await collection();
      await collection_user.update({
        profile_pic: url,
      });

      return { status: true, error: "", url: url };
    } catch (error) {
      return { status: false, error: error.message, url: "" };
    }
  }
}

async function UPDATE_USER_SUBSCRIPTION(data) {
  if (IS_BUNDLE_APP) {
    try {
      const collection_user = await collectionBundle();
      await collection_user.update(data);
      return { status: true, error: "" };
    } catch (error) {
      return { status: false, error: error.message };
    }
  } else {
    try {
      const collection_user = await collection();
      await collection_user.update(data);
      return { status: true, error: "" };
    } catch (error) {
      return { status: false, error: error.message };
    }
  }
}

 async function GET_STRIPE_DETAILS(uid) {
  try {
    const customerCollection = firestore()
      .collection("customers")
      .doc(uid)
      .collection("subscriptions");
    const result = await customerCollection.get();
    let list = [];
    result.forEach((documentSnapshot) => {
      var data = documentSnapshot.data();
      data.doc_id = documentSnapshot.id;
      list.push(data);
    });
    // Filter to our product only. Intentionally NOT filtering by status — derivation
    // needs to see cancelled / past_due / canceled / unpaid subs so it can surface
    // "Won't renew", billing issues, refunds, and grace periods. The legacy
    // status==='active' filter silently hid all of these.
    const filterData = list?.filter(
      (ele) => ele?.product?.id === THIRD_PARTY_CONFIG.STRIPE_PRODUCT_ID
    );

    for (const item of filterData) {
      if (item.price) {
        const priceDoc = await item.price.get();
        if (priceDoc.exists) {
          item.priceDetails = priceDoc.data();
        }
      }
    }

    return { status: true, data: filterData, error: "" };
  } catch (err) {
    return { status: false, data: [], error: err?.message };
  }
}

async function GET_USER_STRIPE_ONE_TIME_PAYMENT(uid) {
  try {
    const customerCollection = firestore()
      .collection("customers")
      .doc(uid)
      .collection("payments")
      .where("status", "==", "succeeded");
    const result = await customerCollection.get();
    let paymentsList = [];

    for (const doc of result.docs) {
      const data = doc.data();

      // Log the type of 'prices' to ensure it's an array containing a DocumentReference
      //console.log("Prices is an array:", Array.isArray(data.prices));
      if (Array.isArray(data.prices) && data.prices.length > 0) {
        //console.log("First element of prices array:", data.prices[0]);

        // Check if the first element is a DocumentReference
        if (data.prices[0] instanceof firestore.DocumentReference) {
          try {
            // Fetch the referenced document
            const priceDoc = await data.prices[0].get();
            if (priceDoc.exists) {
              // Add the fetched price data to the payment object
              data.priceData = priceDoc.data();
            }
          } catch (err) {
            console.error("Error fetching price document:", err);
          }
        }
        paymentsList.push(data);
      }
    }

    paymentsList.sort((a, b) => b.created - a.created);
    //console.log("Payments list:", paymentsList);
    // Filter the payments list based on the product ID within the fetched price data
    const filteredPayments = paymentsList.filter(
      (payment) =>
        payment?.priceData?.product === THIRD_PARTY_CONFIG?.STRIPE_PRODUCT_ID
    );
    //console.log("Filtered payments:", filteredPayments);
    if (filteredPayments.length > 0) {
      return { status: true, data: filteredPayments, error: "" };
    } else {
      return {
        status: false,
        error: "No payments found matching the product ID.",
      };
    }
  } catch (err) {
    console.error("Error fetching user stripe one-time payment:", err);
    return {
      status: false,
      error: err.message || "An error occurred while fetching payments.",
    };
  }
}

async function GET_REVENUECAT_METADATA(appName) {
  try {
      // Get all documents from the 'products' collection
      const result = await firestore()
          .collection('metadata')
          .doc('revenuecat')
          .collection('products')
          .get();

      let filteredData = [];

      // Loop through the documents and filter based on 'app' field
      result.forEach((documentSnapshot) => {
          const data = documentSnapshot.data();
          if (data.app === appName) {
              filteredData.push({ id: documentSnapshot.id, ...data });
          }
      });

      // Return the filtered data
      if (filteredData.length > 0) {
          return { status: true, data: filteredData, error: '' };
      } else {
          return { status: false, error: 'No matching documents found' };
      }
  } catch (error) {
      return { status: false, error: error.message };
  }
}

async function GET_REVENUECAT_EVENTS() {
try {
  const result = await firestore().collection('revenuecat').doc(getEffectiveUid()).collection('events').get()
  var list = []
  result.forEach(documentSnapshot => {
      var data = documentSnapshot.data()
      data.doc_id = documentSnapshot.id
      list.push(data)
  });

  if (list.length > 0) {
      return { status: true, data: list, error: '' }
  }
  else {
      return { status: true, data: [], error: '' }
  }
}
catch (error) {
  return { status: false, error: error.message }
}

}

 async function GET_REVENUECAT_SUBSCRIPTION_PLAN(productIdentifier) {
  try {
          const result = await firestore().collection('metadata').doc('revenuecat').collection('products').doc(productIdentifier).get()
          return { status: true, data: result.data().plan, error: '' }
        
  }
  catch (error) {
      return { status: false, error: error.message }
  }
} 

  

async function GET_CURRENCY_PRICE(priceId, currencyCode) {
  try {
    const stripe = await getStripe();
    //console.log(stripe, "stripe data");
    const response = await stripe.prices.retrieve(priceId, {
      expand: ["tiers"],
    });
    //console.log(response, "response data");

    const currencyOptions = response?.data?.currency_options;

    if (currencyOptions) {
      const unitAmount = currencyOptions[currencyCode]?.unit_amount;

      return {
        status: true,
        data: {
          currency_options: currencyOptions,
          currency: currencyCode,
          unit_amount: unitAmount,
        },
        error: null,
      };
    } else {
      return {
        status: false,
        data: null,
        error: "No currency options available",
      };
    }
  } catch (err) {
    console.error("Error fetching currency price:", err);
    return { status: false, data: null, error: err?.message };
  }
}

async function GET_COUNTRY_CODE() {
  try {
    // Country override for pricing checks without a VPN — any dev/test build,
    // and in production only for the signed-in admin (api/admin.js). Session-
    // scoped like ghost mode, so it dies with the tab. In the browser console:
    //   sessionStorage.setItem('lz_country_override', 'IN'); location.reload()
    //   sessionStorage.removeItem('lz_country_override'); location.reload()
    // Display only: Stripe Checkout still picks the charge currency from the
    // real IP, so an overridden page can show INR while Checkout bills USD.
    const override = window.sessionStorage?.getItem("lz_country_override");
    if (override && /^[A-Z]{2}$/i.test(override) &&
        (process.env.NODE_ENV !== "production" || isAdminSignedIn())) {
      return override.toUpperCase();
    }
    const countryData = await axios.get("https://api.country.is");
    //console.log(countryData.data, "get country data api");
    return countryData?.data?.country;
    /* 
    const countryDetails = await axios.get(
      `https://restcountries.com/v3.1/alpha/${countryData?.data?.country}`
    );
    const formattedCurrencies = Object.entries(
      countryDetails?.data[0]?.currencies
    ).map(([currencyCode, currencyData]) => ({
      currencyCode: currencyCode,
      name: currencyData?.name,
      symbol: currencyData?.symbol,
      country: countryData?.data?.country,
      ip: countryData?.data?.ip,
    }));

    // console.log(
    //   countryDetails?.data[0]?.currencies,
    //   "all country details ------------"
    // );
    return { status: true, data: formattedCurrencies[0], error: "error" }; */
  } catch (err) {
    return "US";
  }
}

async function UPDATE_USER_TEST_OPTIONS(time_per_question, allow_go_back) {
  try {
    const collection_user = await collection();
    await collection_user.update({
      time_per_question: time_per_question,
      allow_go_back: allow_go_back,
    });
    return { status: true, error: "" };
  } catch (error) {
    return { status: false, error: error.message };
  }
}

async function UPDATE_USER_THEME(theme) {
  if (IS_BUNDLE_APP) {
    try {
      const collection_user = await collectionBundle();
      await collection_user.update({
        app_theme: theme,
      });
      return { status: true, error: "" };
    } catch (error) {
      return { status: false, error: error.message };
    }
  } else {
    try {
      const collection_user = await collection();
      await collection_user.update({
        app_theme: theme,
      });
      return { status: true, error: "" };
    } catch (error) {
      return { status: false, error: error.message };
    }
  }
}

async function UPDATE_USER_FONTS_OPTIONS(font_size) {
  if (IS_BUNDLE_APP) {
    try {
      const collection_user = await collectionBundle();
      await collection_user.update({
        font_size: font_size,
      });
      return { status: true, error: "" };
    } catch (error) {
      return { status: false, error: error.message };
    }
  } else {
    try {
      const collection_user = await collection();
      await collection_user.update({
        font_size: font_size,
      });
      return { status: true, error: "" };
    } catch (error) {
      return { status: false, error: error.message };
    }
  }
}

async function UPDATE_PREFFERED_NAME(name) {
  try {
      const APP_NAME = await GET_APP_NAME_FOR_COLLECTION()

      if (IS_BUNDLE_APP) {
        try {
          const collection_user = await collectionBundle();
          await collection_user.update({
            preffered_name: name,
          });
          return { status: true, error: "" };
        } catch (error) {
          return { status: false, error: error.message };
        }
      } else {
        try {
          const collection_user = await collection();
          await collection_user.update({
            preffered_name: name,
          });
          return { status: true, error: "" };
        } catch (error) {
          return { status: false, error: error.message };
        }
      }
         
  }
  catch (error) {
      return { status: false, error: error.message }
  }
}


async function UPDATE_STUDY_PREFERENACE(time) {
  try {
      const collection_user = await collection()
      await collection_user.update({
          onboarding_study_preferenace: time,
      })
      return { status: true, error: '' }
  }
  catch (error) {
      return { status: false, error: error.message }
  }
}

async function UPDATE_TIME_PREFERENACE(time) {
  try {
      const collection_user = await collection()
      await collection_user.update({
          onboarding_time_preferenace: time,
      })
      return { status: true, error: '' }
  }
  catch (error) {
      return { status: false, error: error.message }
  }
}

async function UPDATE_EXAM_DATA(date) {
  try {
      const collection_user = await collection()
      await collection_user.update({
          onboarding_exam_date: date,
      })
      return { status: true, error: '' }
  }
  catch (error) {
      return { status: false, error: error.message }
  }
}

async function DELETE_USER(uid) {
  try {
    const APP_NAME = await GET_APP_NAME_FOR_COLLECTION();
    const userCollection = firestore()
      .collection("apps")
      .doc(APP_NAME)
      .collection("users")
      .doc(uid);
    const result = await userCollection.delete();
    return { status: true, error: "" };
  } catch (error) {
    return { status: false, error: error.message };
  }
}

async function DELETE_BUNDLE_USER(uid) {
  try {
    const userCollection = firestore()
      .collection("apps")
      .doc(BUNDLE_APP_NAME)
      .collection("users")
      .doc(uid);
    const result = await userCollection.delete();
    return { status: true, error: "" };
  } catch (error) {
    return { status: false, error: error.message };
  }
}

async function GET_FAQS() {
  try {
    const collection_faq = await faqCollection();
    const result = await collection_faq.orderBy("id", "asc").get();
    var list = [];
    result.forEach((documentSnapshot) => {
      var data = documentSnapshot.data();
      data.doc_id = documentSnapshot.id;
      list.push(data);
    });

    if (list.length > 0) {
      return { status: true, data: list, error: "" };
    } else {
      return { status: false, error: "No Faqs available yet" };
    }
  } catch (error) {
    return { status: false, error: error.message };
  }
}

async function GET_ALL_USERS() {
  try {
    const collection_faq = await allUserCollection();
    const result = await collection_faq.get();
    var list = [];
    result.forEach((documentSnapshot) => {
      var data = documentSnapshot.data();
      data.doc_id = documentSnapshot.id;
      list.push(data);
    });

    if (list.length > 0) {
      return { status: true, data: list, error: "" };
    } else {
      return { status: false, error: "No users available yet" };
    }
  } catch (error) {
    return { status: false, error: error.message };
  }
}

async function GET_COMMON_FAQS() {
  try {
    const collection_faq = await commonFaqs();
    const result = await collection_faq.orderBy("id", "asc").get();
    var list = [];
    result.forEach((documentSnapshot) => {
      var data = documentSnapshot.data();
      data.doc_id = documentSnapshot.id;
      list.push(data);
    });

    if (list.length > 0) {
      return { status: true, data: list, error: "" };
    } else {
      return { status: false, error: "No Faqs available yet" };
    }
  } catch (error) {
    return { status: false, error: error.message };
  }
}

async function GET_OTHER_APPS() {
  try {
    const result = await otherAppCollection().get();
    var list = [];
    result.forEach((documentSnapshot) => {
      var data = documentSnapshot.data();
      data.doc_id = documentSnapshot.id;
      list.push(data);
    });

    if (list.length > 0) {
      return { status: true, data: list, error: "" };
    } else {
      return { status: false, error: "No other apps available yet" };
    }
  } catch (error) {
    return { status: false, error: error.message };
  }
}

async function STORE_AUTH_DETAILS(APP_NAME) {
  // Skip in ghost mode — don't write admin's details to ghost user's AUTH doc
  if (isGhostMode()) return;

  const result = await firestore()
    .collection("apps")
    .doc("AUTH")
    .collection("users")
    .doc(getEffectiveUid())
    .get();

    // console.log('>>>>>>>>>>>>>>>> STORE_AUTH_DETAILS result', firestore.FieldValue.arrayUnion(APP_NAME));

  if (result.exists) {
    firestore()
      .collection("apps")
      .doc("AUTH")
      .collection("users")
      .doc(getEffectiveUid())
      .update({
        apps: firestore.FieldValue.arrayUnion(APP_NAME),
        email: auth().currentUser.email,
      });
  } else {
    firestore()
      .collection("apps")
      .doc("AUTH")
      .collection("users")
      .doc(getEffectiveUid())
      .set({
        apps: firestore.FieldValue.arrayUnion(APP_NAME),
        email: auth().currentUser.email,
      });
  }
}

async function GET_STORE_AUTH_DETAILS() {
  try {
    const result = await firestore()
      .collection("apps")
      .doc("AUTH")
      .collection("users")
      .doc(getEffectiveUid())
      .get();
    if (result.exists) {
      return {
        status: true,
        data: result.data(),
        error: "",
        isUserExist: true,
      };
    } else {
      return { status: true, data: null, error: "", isUserExist: false };
    }
  } catch (error) {
    return { status: false, error: error.message };
  }
}

async function SET_CERTIFICATE_NAME(certificate) {
  // Skip in ghost mode — don't overwrite ghost user's auth details with admin's
  if (isGhostMode()) return { status: true, error: '' };

  try {
    const collection_user = await collectionBundle();
    const result = await collection_user.get();

    if (result.exists) {
      const collection_user = await collectionBundle();
      await collection_user.update({
        auth_email: auth().currentUser.email,
        auth_login_provider:
          auth().currentUser?.providerData[0]?.providerId ?? "",
        last_signin_time: auth().currentUser.metadata?.lastSignInTime ?? "",
        signup_date: auth().currentUser.metadata?.creationTime ?? "",
        current_certificate: certificate,
      });
      return { status: true, error: "" };
    } else {
      const collection_user = await collectionBundle();
      await collection_user.set({
        auth_email: auth().currentUser.email,
        auth_login_provider:
          auth().currentUser?.providerData[0]?.providerId ?? "",
        last_signin_time: auth().currentUser.metadata?.lastSignInTime ?? "",
        signup_date: auth().currentUser.metadata?.creationTime ?? "",
        current_certificate: certificate,
      });
      return { status: true, error: "" };
    }
  } catch (error) {
    return { status: false, error: error.message };
  }
}

// Function to get active promotion codes from Firestore
const getActivePromotionCodes = async () => {
  try {
    const promotionCodesSnapshot = await firestore().collection('promotionCodes').get();
    const promotionCodes = {};
    // Stripe's `active` flag and `expires_at` are independent — Stripe does not
    // auto-flip `active` to false when a promotion_code's window passes. Filter
    // expired codes (and codes whose underlying coupon is no longer valid) here
    // so the UI doesn't accept a code Stripe will reject at checkout.
    const nowSec = Math.floor(Date.now() / 1000);
    promotionCodesSnapshot.forEach((doc) => {
      const data = doc.data();
      const coupon = data.coupon || {};
      const isActive = data.active === true;
      const notExpired = !data.expires_at || data.expires_at > nowSec;
      const couponValid = coupon.valid !== false;
      const couponNotExpired = !coupon.redeem_by || coupon.redeem_by > nowSec;
      // Option (a): only percent-off codes are supported in-app. A fixed-amount
      // (amount_off) coupon carries no percent_off, so the paywall can't render
      // or compute its discount — surfacing it would dead-end the user with a
      // false "Invalid" at apply time. Filter it out here so it never enters the
      // map; the honest failure reason then stays code_not_found. (Fixed-amount
      // codes still work via Stripe's allow_promotion_codes at checkout.)
      const hasPercentOff =
        typeof coupon.percent_off === "number" && coupon.percent_off > 0;
      if (isActive && notExpired && couponValid && couponNotExpired && hasPercentOff) {
        // Key with the same normalizer the readers use, so a whitespace-bearing
        // Firestore `code` stays matchable in-UI (one-sided normalization would
        // make it unmatchable). See @learnzapp/core/pricing.
        promotionCodes[normalizePromoCode(data.code)] = {
          percent_off: coupon.percent_off,
          id: data.id,
        };
      }
    });
    return promotionCodes;
  } catch (error) {
    console.error("Error fetching promotion codes: ", error);
    throw error;
  }
};

// Returns the currently-active win-back promotion (tagged purpose:'winback'
// in the promotionCodes collection), or null. Same validity gates as
// getActivePromotionCodes — active flag, not expired, coupon still valid. If
// multiple docs are mistakenly tagged 'winback', picks the first valid match;
// ops should keep only one active at a time. Used by PremiumBanner (to gate
// the win-back variant) and choosePlans (to auto-apply for churned users).
const GET_WINBACK_PROMO = async () => {
  try {
    const snap = await firestore()
      .collection('promotionCodes')
      .where('purpose', '==', 'winback')
      .where('active', '==', true)
      .get();
    if (snap.empty) return null;
    const nowSec = Math.floor(Date.now() / 1000);
    let winner = null;
    snap.forEach((doc) => {
      if (winner) return;
      const data = doc.data();
      const coupon = data.coupon || {};
      const notExpired = !data.expires_at || data.expires_at > nowSec;
      const couponValid = coupon.valid !== false;
      const couponNotExpired = !coupon.redeem_by || coupon.redeem_by > nowSec;
      if (notExpired && couponValid && couponNotExpired) {
        winner = {
          code: data.code,
          percent_off: coupon.percent_off,
          id: data.id,
        };
      }
    });
    return winner;
  } catch (error) {
    console.error('Error fetching winback promo:', error);
    return null;
  }
};

// Writes one cancellation-survey response to the top-level
// apps/{BUNDLE}/cancellation_surveys/{auto-id} collection. Auto-IDs let one
// user submit multiple surveys over time (cancel → resubscribe → cancel
// again). Skipped in ghost mode so support impersonation doesn't pollute the
// real user's record.
async function WRITE_CANCELLATION_SURVEY(survey) {
  if (isGhostMode()) return { status: true, skipped: true };
  try {
    const APP_NAME = IS_BUNDLE_APP
      ? BUNDLE_APP_NAME
      : await GET_APP_NAME_FOR_COLLECTION();
    const doc = {
      uid: getEffectiveUid(),
      auth_email: auth().currentUser?.email || null,
      submitted_at: firestore.FieldValue.serverTimestamp(),
      ...survey,
    };
    await firestore()
      .collection('apps')
      .doc(APP_NAME)
      .collection('cancellation_surveys')
      .add(doc);
    return { status: true, error: '' };
  } catch (error) {
    console.error('Failed to write cancellation survey:', error?.message);
    return { status: false, error: error?.message };
  }
}

// Writes one publishable success story to apps/{APP}/success_stories/{auto-id}.
// Curated review queue: every write lands as status:'pending_review' /
// published:false, forced here regardless of any caller-supplied value — nothing
// auto-publishes. A reviewer flips status→'approved' and published→true
// server-side/console before it goes live on learnzapp.com. Clicking "Publish my
// story" IS the consent, so the caller passes consent_given + consent_text_version
// (the exact disclosure string shown) for the audit record; consent_timestamp is
// stamped here. Skipped in ghost mode. Mirrors WRITE_CANCELLATION_SURVEY.
async function WRITE_SUCCESS_STORY(story) {
  if (isGhostMode()) return { status: true, skipped: true };
  try {
    const APP_NAME = IS_BUNDLE_APP
      ? BUNDLE_APP_NAME
      : await GET_APP_NAME_FOR_COLLECTION();
    const doc = {
      user_id: getEffectiveUid(),
      auth_email: auth().currentUser?.email || null,
      app: APP_NAME,
      exam: null,
      display_name: null,
      story_text: null,
      weeks_to_prepare: null,
      linkedin_url: null,
      ...story,
      // Audit + review-queue fields forced after the spread so a caller can't
      // override them: consent is recorded, status/published stay pending.
      consent_given: true,
      consent_timestamp: firestore.FieldValue.serverTimestamp(),
      source: 'web_cancellation_success_churn',
      status: 'pending_review',
      published: false,
      created_at: firestore.FieldValue.serverTimestamp(),
    };
    await firestore()
      .collection('apps')
      .doc(APP_NAME)
      .collection('success_stories')
      .add(doc);
    return { status: true, error: '' };
  } catch (error) {
    console.error('Failed to write success story:', error?.message);
    return { status: false, error: error?.message };
  }
}

// Writes one free-text feedback entry to apps/{APP}/feedback/{auto-id}. Used by
// the post-cancel "passed but not helped" branch. Skipped in ghost mode.
async function WRITE_FEEDBACK(feedback) {
  if (isGhostMode()) return { status: true, skipped: true };
  try {
    const APP_NAME = IS_BUNDLE_APP
      ? BUNDLE_APP_NAME
      : await GET_APP_NAME_FOR_COLLECTION();
    const doc = {
      uid: getEffectiveUid(),
      auth_email: auth().currentUser?.email || null,
      app: APP_NAME,
      created_at: firestore.FieldValue.serverTimestamp(),
      ...feedback,
    };
    await firestore()
      .collection('apps')
      .doc(APP_NAME)
      .collection('feedback')
      .add(doc);
    return { status: true, error: '' };
  } catch (error) {
    console.error('Failed to write feedback:', error?.message);
    return { status: false, error: error?.message };
  }
}

// Records that the near-expiry "extend" nudge was shown for `tier` in the CURRENT
// expiry window. Cycle-scoped by `expiryMs`: when the stored window differs (a
// repurchase moved the expiry), the seen-tier list resets, so a repeat buyer is
// nudged again next cycle. Persisted on the user doc (cross-device, and the same
// field mobile reads when it wires the nudge) rather than per-device localStorage.
async function UPDATE_EXTEND_NUDGE_SEEN(expiryMs, tier, isBundle = false) {
  try {
    const ref = await (isBundle ? collectionBundle() : collection());
    const snap = await ref.get();
    const cur = snap.exists ? snap.data()?.nudge_state?.extend : null;
    const exp = Number(expiryMs);
    const tiers = cur && Number(cur.expiry) === exp
      ? Array.from(new Set([...(Array.isArray(cur.tiers) ? cur.tiers : []), tier]))
      : [tier];
    await ref.set({ nudge_state: { extend: { expiry: exp, tiers } } }, { merge: true });
    return { status: true, error: '' };
  } catch (error) {
    console.error('Failed to record extend nudge seen:', error?.message);
    return { status: false, error: error?.message };
  }
}


export {
  UPDATE_USER_PROFILE,
  UPDATE_BUNDLE_USER_PROFILE,
  GET_USER_PROFILE,
  GET_BUNDLE_PROFILE,
  UPDATE_NOTIFICATION_SETTING,
  UPLOAD_PROFILE,
  UPDATE_PROFILE_DETAILS,
  UPDATE_BUNDLE_PROFILE_DETAILS,
  UPDATE_USER_SUBSCRIPTION,
  UPDATE_EXTEND_NUDGE_SEEN,
  GET_USER_STRIPE_ONE_TIME_PAYMENT,
  GET_STRIPE_DETAILS,
  GET_CURRENCY_PRICE,
  GET_COUNTRY_CODE,
  UPDATE_USER_TEST_OPTIONS,
  DELETE_USER,
  DELETE_BUNDLE_USER,
  GET_FAQS,
  GET_OTHER_APPS,
  STORE_AUTH_DETAILS,
  GET_STORE_AUTH_DETAILS,
  UPDATE_USER_AUTH_DETAILS,
  SET_CERTIFICATE_NAME,
  GET_COMMON_FAQS,
  GET_ALL_USERS,
  UPDATE_USER_FONTS_OPTIONS,
  UPDATE_USER_THEME,
  getActivePromotionCodes,
  GET_WINBACK_PROMO,
  UPDATE_PREFFERED_NAME,
  UPDATE_STUDY_PREFERENACE,
  UPDATE_TIME_PREFERENACE,
  UPDATE_EXAM_DATA,
  WRITE_CANCELLATION_SURVEY,
  WRITE_SUCCESS_STORY,
  WRITE_FEEDBACK,
    GET_REVENUECAT_EVENTS,
    GET_REVENUECAT_METADATA,
    GET_REVENUECAT_SUBSCRIPTION_PLAN
};
